import { render, staticRenderFns } from "./CompanyStatusC2.vue?vue&type=template&id=f3f44c88"
import script from "./CompanyStatusC2.vue?vue&type=script&lang=js"
export * from "./CompanyStatusC2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports